import React from 'react';
import { STYLOVYZE_FLAGS } from '../../types/features';
import { useIsFeatureEnabled } from '../../utils/features';
import { AnalyticsProvider } from './AnalyticsProvider';
export const AnalyticsProviderWrapper = ({ children, }) => {
    const useAnalytics = !!useIsFeatureEnabled(STYLOVYZE_FLAGS.ADSK_ADP_ANALYTICS);
    return (React.createElement(AnalyticsProvider, { useAdpAnalytics: useAnalytics }, children));
};
export default AnalyticsProviderWrapper;
